const PowerStationIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.40015 10.4004H25.6001" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M6.40015 24H25.6001" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
      <line
        x1="7.40005"
        y1="11.0004"
        x2="7.40005"
        y2="23.4004"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="11.0001"
        y1="8.6"
        x2="11.0001"
        y2="9.8"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="20.9999"
        y1="8.6"
        x2="20.9999"
        y2="9.8"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="24.6"
        y1="10.6"
        x2="24.6"
        y2="23.4"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.2727 14L14.2584 17.1556C14.1612 17.2574 14.2333 17.4261 14.3741 17.4261H17.6236C17.7648 17.4261 17.8368 17.5955 17.7389 17.6971L14.3636 21.2"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default PowerStationIcon
